import { useEffect, useState } from "react"
import Frame from "../Frames/Basic";
import { Stack, Alert, Button, Typography } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";
import Loader from "../Tools/Loader";
import Tracker from "../../services/Tracker";
import Invoice from "./Invoice";
import API from "../../services/API";

export default function Success(){

    const {uuid} = useParams()

    const [order, setOrder] = useState(null)

    const [status, setStatus] = useState('loading')
    
    const statusIs = s => s === status
    const statusIsNot = s => s !== status

    useEffect(() => {

        const onSuccess = data => {

            console.log(data)

            setStatus('success')
            setOrder(data)

            Tracker.handleOrder(data)
        }

        API.put(`/orders/${uuid}/complete`)
            .then(r => onSuccess(r.data))
            .catch(e => setStatus('error'))
        

    }, [uuid])


    const retry = () => {

        setStatus('loading')

        API.put(`/orders/${uuid}/complete`)
            .then(r => setStatus('success'))
            .catch(e => setStatus('error'))
    }


    if(statusIs('redirect')) return <Navigate to="/" />


    return <Frame>

        <Stack direction='column' spacing={3} sx={{maxWidth: 600}}>

            <Typography variant='h2'>Validation de votre commande</Typography>

            {statusIs('loading') &&
                <Loader />
            }

            {statusIs('success') && 

                <Alert severity='success'>
                    🎉 Félicitations ! Votre commande a bien été prise en compte. 
                </Alert>
            }

            {statusIs('error') && <>

                <Alert severity='error'>
                    Une erreur s'est produite. Votre commande n'a pas été prise en compte.
                </Alert>

                <Button
                    onClick={retry}
                >
                    Réessayer
                </Button>
            
            </>}


            <Invoice order={order}/>
            

            {statusIsNot('loading') &&

               <Button variant='outlined' onClick={() => setStatus('redirect')}>
                    Retour à l'accueil
                </Button>
            }


        </Stack>

    </Frame>
}